import styled, { css } from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { iconSizeOptions, iconSizes } from '../icons/icons-sizes'
import { statusIndicationSizeOptions } from './constants'

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  position: relative;
  width: fit-content;
`

export const ImageContainer = styled.div`
  ${({ size = iconSizeOptions['ICON-M'] }) => css`
    ${iconSizes[size]}
  `}
`

export const Image = styled.img`
  border-radius: 50%;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  object-fit: cover;
  &[data-inactive='true'] {
    filter: grayscale(100%);
  }
`

export const StatusIndicatorContainer = styled.div`
  position: absolute;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 3%;
  right: 3%;
  ${({ size = iconSizeOptions['ICON-M'] }) => css`
    ${statusIndicationSizeOptions[size]}
  `}
`

export const StatusIndicatorInvited = styled.span`
  background-color: ${colorsOptions.semantics.info.normal};
  border-radius: 50%;
`

export const StatusIndicatorActive = styled(StatusIndicatorInvited)`
  background-color: ${colorsOptions.semantics.success.normal};
`

export const StatusIndicatorUnlicensed = styled(StatusIndicatorInvited)`
  background-color: ${colorsOptions.semantics.danger.error};
`

export const StatusIndicatorInactive = styled(StatusIndicatorInvited)`
  background-color: ${colorsOptions.greys['grey-40']};
`
